<template>
  <FlexColumn :space="0">
    <FlexRow v-for="(item, index) in languages" :key="`languages-label-${index}`">
      <Label :bold="bold" :text="languageName(item)"/>
      <Label :bold="bold" text="："/>
      <Label :bold="bold" :text="languageLevel(item)"/>
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import FlexRow from "@/components/atoms/FlexRow";
import {mapGetters} from "vuex";
import Label from "@/components/atoms/Label";
export default {
  name: "LanguagesLabel",
  components: {Label, FlexRow, FlexColumn},
  props: {
    languages: {
      type: Array
    },
    bold: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    languageName() {
      return (language) => {
        if (language.language === 4) {
          return language.otherLanguage
        }
        if (this.consts.language) {
          return this.consts.language.find(item => item.value === language.language).label
        }
        return ""
      }
    },
    languageLevel() {
      return (language) => {
        if (this.consts.languageLevel) {
          return this.consts.languageLevel.find(item => item.value === language.languageLevel).label
        }
        return ""
      }
    }
  }
}
</script>

<style scoped>

</style>